// Maps the live /travel API trip onto the shape the ported travel card expects
// (see cards.js travelCard + data.js TRAVEL). The API already returns the card
// shape; this just guarantees arrays/dates exist so the template stays dumb.
import type { Trip } from "../services/travelService";

export interface SergaTrip {
  id: string;
  destination: string;
  title: string;
  status: string;
  dates: { start: string | null; end: string | null; flexible: boolean };
  purpose: string;
  linkedProject?: string;
  transport: any[];
  accommodation: any[];
  checklist: any[];
  notes: string;
}

export function mapTrip(t: Trip): SergaTrip {
  return {
    id: t.id,
    destination: t.destination,
    title: t.title || t.destination,
    status: String(t.status || "idea").toLowerCase(),
    dates: {
      start: t.dates?.start ?? null,
      end: t.dates?.end ?? null,
      flexible: !!t.dates?.flexible,
    },
    purpose: t.purpose || "",
    ...(t.linkedProject ? { linkedProject: t.linkedProject } : {}),
    transport: Array.isArray(t.transport) ? t.transport : [],
    accommodation: Array.isArray(t.accommodation) ? t.accommodation : [],
    checklist: Array.isArray(t.checklist) ? t.checklist : [],
    notes: t.notes || "",
  };
}
